module.exports = __webpack_public_path__ + "img/people-info2.98953c37.png";